var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.label } },
    [
      !_vm.info || _vm.info.length === 0
        ? _c("span", { staticClass: "item-empty-char" }, [
            _vm._v(_vm._s(_vm.emptyChar)),
          ])
        : _vm._e(),
      _vm.info && !_vm.$slots.default
        ? _c("span", [_vm._v(_vm._s(_vm.info))])
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }